import React, {Component} from 'react';
import {GROUP_OWNER, GROUP_STAFF} from "../../../data/userGroups";
import {connect} from "react-redux";
import {getMyProfile} from "../../../actions/user";
import {saveOrder} from "../../../actions/orders";
import {history} from "../../../store";
import YourPersonalRewards from '../../home/personal-rewards/index';
import SaveForLaterDialog from '../../new-order/save';
import PrivacyPopup from '../../common/privacy-policy/privacy-popup';
import MarketingConsentPopup from '../../common/marketing/marketing-consent-popup'
import UserGroupGuard from "../../common/guards/user-group";
import {checkPermission} from '../../common/guards/can';
import VoucherSelectionPopup from "../../store-summary/voucher-select/voucher-selection-popup";
import DefaultStorePopup from '../../your-store/default-store-popup';

const outletSettingsExceptionRoutes = [
  '/outlet',
  '/your-store',
  '/registration/outlet',
  '/registration/your-store',
  '/registration/store-summary',
  '/store-summary'
];


class MainPopups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false
    }
  }

  handleSaveForLater = (result, value) => {
    const {dispatch} = this.props;

    if (result) {
      dispatch(saveOrder(value))
        .then(() => {
          dispatch(getMyProfile('CURRENT_USER_PROFILE'));
          history.push('/order/new');
        });
    }
    dispatch({type: 'TOGGLE_SAVE_ORDER_DIALOG'});
  };

  showExcept = (routes) => !routes.includes(window.location.pathname);

  popupActive = (bool) => {
    this.setState({
      popup: bool
    })
  }

  render() {
    let {
      showPersonalRewardsSettings, showMarketingConsentPopup,
      showPrivacyPopup, showSaveOrderDialog,
      profile
    } = this.props.viewConfig;
    let { showDefaultStorePopup, features } = this.props;
    const pseudo = profile.attributes['pseudo-login'];

    showPrivacyPopup = showPrivacyPopup && !pseudo;
    if (features['new_ordering']) {
      showPersonalRewardsSettings = showPersonalRewardsSettings && !showDefaultStorePopup;
      showDefaultStorePopup = showDefaultStorePopup && !showPrivacyPopup;
    } else {
      showPersonalRewardsSettings = showPersonalRewardsSettings && !showPrivacyPopup;
      showDefaultStorePopup = false;
    }
    showMarketingConsentPopup = showMarketingConsentPopup && !showPersonalRewardsSettings && !showPrivacyPopup;
    showSaveOrderDialog = showSaveOrderDialog && !showPrivacyPopup;
    const showStaffRewardVouchers = !showMarketingConsentPopup && checkPermission('handle', 'staff_rewards') && profile.attributes['has-reward-outlet'] && !profile.attributes['voucher-type-id'] && profile.attributes['user-group'] !== 'account_manager';

    let activePopup = '';
    if (showPrivacyPopup) {
      activePopup = 'showPrivacyPopup';
    } else if (showMarketingConsentPopup) {
      activePopup = 'showMarketingConsentPopup';
    } else if (showDefaultStorePopup) {
      activePopup = 'showDefaultStorePopup';
    } else if (showStaffRewardVouchers) {
      activePopup = 'showStaffRewardVouchers';
    } else if (showPersonalRewardsSettings) {
      activePopup = 'showPersonalRewardsSettings';
    } else if (showSaveOrderDialog) {
      activePopup = 'showSaveOrderDialog';
    };

    return (
      <div>
        {activePopup === 'showPrivacyPopup' && <PrivacyPopup show={showPrivacyPopup} popupActive={this.popupActive} />}

        {activePopup === 'showMarketingConsentPopup' &&
          <UserGroupGuard type={[GROUP_OWNER, GROUP_STAFF]}>
            <MarketingConsentPopup show={showMarketingConsentPopup} popupActive={this.popupActive} />
          </UserGroupGuard>
        }

        { features['new_ordering'] && this.showExcept(outletSettingsExceptionRoutes) && (
          <UserGroupGuard type={GROUP_OWNER}>
            {activePopup === 'showDefaultStorePopup' && <DefaultStorePopup popupActive={this.popupActive} />}
          </UserGroupGuard>
        )}

        {activePopup === 'showStaffRewardVouchers' && <VoucherSelectionPopup show={this.showExcept(outletSettingsExceptionRoutes)} popupActive={this.popupActive} />}

        {activePopup === 'showPersonalRewardsSettings' && <YourPersonalRewards popupActive={this.popupActive} />}

        {activePopup === 'showSaveOrderDialog' && <SaveForLaterDialog onClose={this.handleSaveForLater} popupActive={this.popupActive} />}
      </div>
    )
  }
}



const mapStateToProps = ({ viewConfig, currentUser, features }) => {
  return {
    viewConfig,
    features,
    currentUser: currentUser.user,
    userLoading: currentUser.fetching,
    showDefaultStorePopup: viewConfig.loaded && !Boolean(viewConfig.profile.attributes['default-outlet-id'])
  };
};

export default connect(mapStateToProps)(MainPopups);



// WEBPACK FOOTER //
// ./src/components/layout/main/main-popups.jsx